import React from 'react';

import ObservationsPanel from '../observations/ObservationsPanel';

/**
 * Onglet « Observations » de la fiche camion: ce qu'on a noté sur le camion et
 * sur ses trajets, plus les incidents, pannes et notes d'étape qui le concernent.
 */
export default function TruckObservationsTab({ truck }) {
  if (!truck?.id) return null;
  return <ObservationsPanel entityType="truck" entityId={truck.id} />;
}
